import React, { Component } from 'react';
import {Grid} from "@material-ui/core";
import moment from 'moment';
import 'moment/min/locales.min';
import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import ButtonAtm from "../../../../atomic/Button/Button";
import {constructListOfIntervals, getNextDates, getPreviousDate, setInventoryDate} from "../../../../../utils";
import {withTranslation} from "react-i18next";
import {compose} from "redux";

let t=null;

const dateFormat = 'YYYY-MM-DD';

class PriceDateRangeAdvanced extends Component {
    constructor(props) {
        super(props);
        this.state = {
            focusedInput: '',
            startDate: moment(this.props.startDate, dateFormat),
            endDate: moment(this.props.endDate, dateFormat),
            allDays: this.props.allDays,
            currency: this.props?.currency
        };
        this.onDatesChange = this.onDatesChange.bind(this)
        this.onFocusChange = this.onFocusChange.bind(this)
        t = props.t;
    }

    onDatesChange({startDate, endDate}) {

        const { getCpa, showCompetitor, trigger } = this.props;
        
        if (trigger !== undefined && trigger !== null && trigger === 0) {
            this.props.getCpaClearState();
        }

        if (endDate != null || startDate != null) {

            if (this.state.focusedInput == "startDate") {
                let endDate = null;
                this.setState({startDate,endDate})
                return
            }

            if (this.state.focusedInput == "endDate") {
                if( (endDate != null && startDate != null) ){
                    let allDays = constructListOfIntervals(moment(startDate).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD"),'day');
                    this.setState({startDate, endDate, allDays}, () => {
                         this.props.getPropertyInvertoryDate( moment(startDate).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD") )
                    });

                    if (showCompetitor) {
                        this.props.getCpaClearState();

                        setTimeout(() => {
                            allDays.map((day) => {
                                getCpa.map((cpa) => {
                                    this.props.getCpaDailyPrice(day, cpa?.key, this.state.currency)
                                });
                            });
                        }, 100);
                    }
                }
            }

        }
        if (this.props.onDateRangeChange) {
            this.props.onDateRangeChange();
        }
    }

    onFocusChange(focusedInput) {
        this.setState({focusedInput});
    }

    isOutsideRange = (day) => {
        if (this.state.focusedInput === "startDate") {
            return day.isBefore(moment(), 'day');
        }

        if (this.state.focusedInput === "endDate") {
            return day.isAfter(moment(this.state.startDate, dateFormat).add(14, 'days')) || day.isBefore(this.state.startDate);
        }
        return false;
    }

    onClickPreviousDate  = () => {
        const {previousDate, getCpa, showCompetitor} = this.props;
        const {startDate,allDays} = this.state;

        let tempAllDays = getPreviousDate( moment(startDate).format("YYYY-MM-DD"), 7,allDays,'day');
        let tempStartDate = tempAllDays[0];
        let tempEndDate = tempAllDays[tempAllDays.length -1];

        previousDate( tempStartDate, tempEndDate );

        this.setState({
            startDate: moment(tempStartDate, dateFormat),
            endDate: moment(tempEndDate, dateFormat),
            allDays: tempAllDays,
        })

        if (showCompetitor) {
            this.props.getCpaClearState();
            window.stop();
            setTimeout(() => {
                tempAllDays.map((day) => {
                    getCpa.map((cpa) => {
                        this.props.getCpaDailyPrice(day, cpa?.key, this.state.currency)
                    });
                });
            }, 100);
        }
    }

    onClickNextDate  = () => {
        const {nextDate, getCpa, showCompetitor} = this.props;
        const {endDate,allDays} = this.state;

        let tempAllDays = getNextDates(moment(endDate).format("YYYY-MM-DD"), 7, allDays, "day");
        let tempStartDate = tempAllDays[0];
        let tempEndDate = tempAllDays[tempAllDays.length -1];

        this.setState({
            startDate: moment(tempStartDate, dateFormat),
            endDate: moment(tempEndDate, dateFormat),
            allDays: tempAllDays,
        })

        if (showCompetitor) {
            this.props.getCpaClearState();
            window.stop();
            setTimeout(() => {
                tempAllDays.map((day) => {
                    getCpa.map((cpa) => {
                        this.props.getCpaDailyPrice(day, cpa?.key, this.state.currency)
                    });
                });
            }, 100);
        }

        nextDate(tempStartDate, tempEndDate);
    }

    render() {
        const {focusedInput, startDate, endDate} = this.state;
        const appLanguage = localStorage.getItem("lng");
        moment.locale(appLanguage)

        setInventoryDate(moment(startDate).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD"))

        // Belirli gün aralıklarına göre spesifik tarihleri hesapla
        const specificDays = [1, 7, 15, 30, 90, 120, 180, 240];
        const specificDates = specificDays.map(addDays => moment().add(addDays, 'days').format("YYYY-MM-DD"));
        localStorage.setItem("allDays", JSON.stringify(specificDates))
                        

        return (
                <Grid container>
                    <Grid item xs={12} sm={12} className="pos-relative">
                        {/* <Grid className="offer-date-icon offer-start-icon">
                            <p style={{position: "relative", left: "10px"}}>{ t('enw-input-from_date') }</p>
                            <i className="far fa-calendar-alt" />
                        </Grid>
                        <DateRangePicker
                            onDatesChange={this.onDatesChange}
                            onFocusChange={this.onFocusChange}
                            focusedInput={focusedInput}
                            startDate={moment(startDate).locale(appLanguage)}
                            endDate={moment(endDate).locale(appLanguage)}
                            displayFormat="MMM DD YYYY"
                            isOutsideRange={this.isOutsideRange}
                            minimumNights={0}
                            numberOfMonths={window.innerWidth < 768 ? 1 : 2}
                        />
                        <Grid className="offer-date-icon offer-end-icon">
                            <p>{ t('enw-input-to_date') }</p>
                            <i className="far fa-calendar-alt" />
                        </Grid> */}
                        <style>{`
                            @media screen and (max-width: 768px) {
                                #startDate {
                                    border-top-right-radius: 0px !important;
                                    border-bottom-right-radius: 0px !important;
                                }
                            }
                            @media screen and (max-width: 768px) {
                                #endDate {
                                    border-top-left-radius: 0px !important;
                                    border-bottom-left-radius: 0px !important;
                                }
                            }
                            .bg-transparent {
                                background-color: transparent !important;
                            }
                            .weekend p.fw-500, .inventory-price-day p.fw-500 {
                                font-weight: 500 !important;
                                margin-bottom:5px;
                            }
                        `}</style>
                    </Grid>
                    {
                        window.innerWidth > 768 &&
                        <Grid item sm={12} className="offer-price-dates">
                            <Grid container className="pos-relative price-dates-m-width">
                                <ButtonAtm
                                    className="inventory-week-button m-r-inventory-auto bg-transparent"
                                    style={{pointerEvents: "none"}}
                                    // startIcon={<i className="fas fa-caret-left" />}
                                    // onClick={this.onClickPreviousDate}
                                    // disabled={this.props.fetching}
                                />
                                {[
                                    1,   // yarın
                                    7,   // +7 gün
                                    15,  // +15 gün
                                    30,  // +30 gün
                                    90,  // +90 gün
                                    120, // +120 gün
                                    180, // +180 gün
                                    240  // +240 gün
                                ].map((addDays, idx) => {
                                    const date = moment().add(addDays, 'days');
                                    return (
                                        <Grid item className="inventory-price-day" key={addDays}>
                                            <Grid className={`${(date.locale('de').weekday() === 5 || date.locale('de').weekday() === 6) ? 'weekend' : 'weekdays'}`}>
                                                <p>{date.locale(appLanguage).format('ddd')}</p>
                                                <p>{date.locale(appLanguage).format('D')}</p>
                                                <p>{date.locale(appLanguage).format('MMM')}</p>
                                                <p className='fw-500'>+{addDays} {t('enw-input-day')}</p>
                                            </Grid>
                                        </Grid>
                                    );
                                })}
                                <ButtonAtm
                                    className="inventory-week-button m-h-auto inventory-week-right-button bg-transparent"
                                    style={{pointerEvents: "none"}}
                                    // startIcon={<i className="fas fa-caret-right" />}
                                    // onClick={this.onClickNextDate}
                                    // disabled={this.props.fetching}
                                />
                            </Grid>
                        </Grid>

                        // <Grid item sm={8} className="offer-price-dates">
                        //     <Grid container className="pos-relative price-dates-m-width">
                        //         <ButtonAtm
                        //             className="inventory-week-button m-r-inventory-auto"
                        //             startIcon={<i className="fas fa-caret-left" />}
                        //             onClick={this.onClickPreviousDate}
                        //             disabled={this.props.fetching}
                        //         />
                        //         {[
                        //             1,   // yarın
                        //             7,   // +7 gün
                        //             15,  // +15 gün
                        //             30,  // +30 gün
                        //             90,  // +90 gün
                        //             120, // +120 gün
                        //             180, // +180 gün
                        //             240  // +240 gün
                        //         ].map((addDays) => (
                        //             <Grid item className="inventory-price-day" key={addDays}>
                        //                 <Grid className="weekdays">
                        //                     <p></p>
                        //                     <p>{addDays} gün</p>
                        //                     <p></p>
                        //                 </Grid>
                        //             </Grid>
                        //         ))}
                        //         <ButtonAtm
                        //             className="inventory-week-button m-h-auto inventory-week-right-button"
                        //             startIcon={<i className="fas fa-caret-right" />}
                        //             onClick={this.onClickNextDate}
                        //             disabled={this.props.fetching}
                        //         />
                        //     </Grid>
                        // </Grid>
                    }
                </Grid>
        );
    }
}


export default compose(withTranslation('common'))(PriceDateRangeAdvanced);
